import { Search } from 'lucide-react';

import type { DataTableToolbarProps } from '~/components/common/data-table/data-table.types';
import { Input } from '~/components/ui/input';

/**
 * Toolbar rendered above the table.
 * Shows a global search input (when enabled) and a bulk-action slot
 * (when rows are selected). Hidden entirely when neither is present.
 */
export function DataTableToolbar({
  enableGlobalFilter,
  globalFilter,
  onGlobalFilterChange,
  bulkActions,
  testId = 'data-table',
}: DataTableToolbarProps) {
  const hasContent = enableGlobalFilter || bulkActions;
  if (!hasContent) return null;

  return (
    <div className="flex items-center justify-between gap-4" data-testid={`${testId}-toolbar`}>
      {enableGlobalFilter ? (
        <div className="relative w-full max-w-sm">
          <Search className="text-muted-foreground absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2" />
          <Input
            placeholder="Search..."
            value={globalFilter}
            onChange={(e) => {
              onGlobalFilterChange(e.target.value);
            }}
            className="pl-9"
            aria-label="Search all columns"
            data-testid={`${testId}-search-input`}
          />
        </div>
      ) : (
        <div />
      )}

      {bulkActions && (
        <div className="flex items-center gap-2" data-testid={`${testId}-bulk-actions`}>
          {bulkActions}
        </div>
      )}
    </div>
  );
}
